<template>
    <div id= "slider">
        <div v-bind:key="feturedChannel.user_id" v-for="feturedChannel in feturedChannels">  
            <streamSlide v-bind:focus_index="feturedChannel.focus_index" v-bind:channel_data="feturedChannel" v-on:slideClicked="slideClicked($event)"></streamSlide>
        </div>
    </div>
</template>

<script>
import streamSlide from './stream-slide'
export default {

  name: 'slider',
  components: {
    streamSlide
  },
  methods: {
    slideClicked (slideIndex) {
      this.feturedChannels.forEach(feturedChannel => {
        feturedChannel.focus_index -= slideIndex
      })
    }
  },
  data () {
    return {
      window_focus: 1,
      feturedChannels: [
        {
          name: 'Swiftor',
          url: 'https://player.twitch.tv/?channel=swiftor&parent=swiftorland.com',
          index: 0,
          focus_index: 0,
          twitch_id: '274625',
          prof_pic: 'https://static-cdn.jtvnw.net/jtv_user_pictures/78313a44-854c-4979-b96b-08945ace61c7-profile_image-70x70.png',
          banner: 'https://static-cdn.jtvnw.net/jtv_user_pictures/e1d49671-4a68-4db9-b00f-bb8b23dc2d16-profile_banner-480.jpg',
          description: 'Gaming with the community since 2008. As the face of SwiftRage, poor anger management comes standard.'
        }, {
          name: 'Crash2Burn',
          url: 'https://player.twitch.tv/?channel=crash2burn&parent=swiftorland.com',
          index: 0,
          focus_index: 1,
          twitch_id: '6342698',
          prof_pic: 'https://static-cdn.jtvnw.net/jtv_user_pictures/crash2burn-profile_image-9233f62d6e218257-70x70.jpeg',
          banner: 'https://static-cdn.jtvnw.net/jtv_user_pictures/crash2burn-profile_banner-6f617cb167a93b5c-480.png',
          description: "Hey I'm crash2burn Kappa"
        }, {
          name: 'Spin247',
          url: 'https://player.twitch.tv/?channel=spin247&parent=swiftorland.com',
          index: 0,
          focus_index: 2,
          twitch_id: '276400590',
          prof_pic: 'https://static-cdn.jtvnw.net/jtv_user_pictures/0623e8bb-24b5-4d81-8138-b976afe9dbe9-profile_image-70x70.png',
          banner: 'https://static-cdn.jtvnw.net/jtv_user_pictures/0623e8bb-24b5-4d81-8138-b976afe9dbe9-profile_image-300x300.png',
          description: 'Play roulette using swiftbucks, Live 24/7'
        }, {
          name: 'SwiftorCasino',
          url: 'https://player.twitch.tv/?channel=swiftorcasino&parent=swiftorland.com',
          index: 0,
          focus_index: -1,
          twitch_id: '432195675',
          prof_pic: 'https://static-cdn.jtvnw.net/jtv_user_pictures/c2e99394-1e2a-4d48-b942-5a804c4cf052-profile_image-70x70.png',
          banner: 'https://static-cdn.jtvnw.net/jtv_user_pictures/9e32e0d7-d202-49d6-a6d4-6381fc27af6d-profile_banner-480.jpeg',
          description: 'Live dealer games for Swiftbucks. Channel is part of the Swiftor community. General Manager: Annorax10 Assistant GM: Reptile__dysfunctionShift Managers:Pit Bosses:Dealers: Annorax, Reptile, Ryygaming'
        }
      ]
    }
  }
}
</script>

<style scoped>
    #slider{
        display: inline-block;
        width: 100%;
        height: 550px;
        overflow: hidden;
        position: relative;
    }
</style>


// WEBPACK FOOTER //
// src/components/slider.vue